// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ServerErrorSortKey {
	LastOccurrence = 0,
	TraceId = 1,
	Total = 2,
	HourlyAverage = 3,
}

export const ServerErrorSortKeyDisplayNames: { [key in keyof typeof ServerErrorSortKey]?: string} = {
	"LastOccurrence": "LastOccurrence",
	0 : "LastOccurrence",
	"TraceId": "TraceId",
	1 : "TraceId",
	"Total": "Total",
	2 : "Total",
	"HourlyAverage": "HourlyAverage",
	3 : "HourlyAverage",
}

export const getServerErrorSortKeyDisplayName = (key: ServerErrorSortKey | (keyof typeof ServerErrorSortKey & string)) => {
	return ServerErrorSortKeyDisplayNames[key];
}

